// extracted by mini-css-extract-plugin
export default {"container":"CheckboxButtonWithLabel_container__gUEzv","label":"CheckboxButtonWithLabel_label__1Y2+y","noBorder":"CheckboxButtonWithLabel_noBorder__1KvpW"};